import React from "react";
import { Link } from "react-router-dom";
import { Linkedin, Youtube, Twitter, Mail, MapPin, Phone } from "lucide-react";
import Logo from "./Logo";
import { footer, brand } from "../mock/mock";

export default function Footer() {
  return (
    <footer className="oe-navy text-white">
      <div className="max-w-[1400px] mx-auto px-5 md:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <div className="bg-white inline-block px-4 py-3 rounded-md">
              <Logo />
            </div>
            <p className="mt-6 text-white/70 text-sm whitespace-pre-line leading-relaxed">
              {footer.address}
            </p>
            <div className="flex items-center gap-3 mt-6">
              {[Linkedin, Youtube, Twitter].map((Icon, i) => (
                <a
                  key={i}
                  href="#"
                  className="w-9 h-9 rounded-full border border-white/30 flex items-center justify-center hover:bg-white hover:text-oe-navy transition-colors"
                  aria-label="social"
                >
                  <Icon size={16} />
                </a>
              ))}
            </div>
          </div>

          {footer.columns.map((col) => (
            <div key={col.title}>
              <h4 className="text-sm font-semibold uppercase tracking-wider mb-5 text-white">
                {col.title}
              </h4>
              <ul className="space-y-3">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <Link
                      to={l.path}
                      className="text-white/70 text-sm hover:text-white transition-colors"
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider mb-5">
              Get in touch
            </h4>
            <a
              href="mailto:kelvin.marshal@oceanenergyindustrials.com"
              className="flex items-center gap-2 text-white/70 text-sm hover:text-white transition-colors mb-3"
            >
              <Mail size={16} /> kelvin.marshal@oceanenergyindustrials.com
            </a>
            <a
              href="tel:4194081113"
              className="flex items-center gap-2 text-white/70 text-sm hover:text-white transition-colors mb-3"
            >
              <Phone size={16} /> 419-408-1113
            </a>
            <p className="flex items-start gap-2 text-white/70 text-sm">
              <MapPin size={16} className="mt-0.5 shrink-0" /> 72 S Emerson Avenue, Montauk, NY 11954
            </p>
            <Link
              to="/contact"
              className="inline-block mt-6 bg-oe-red text-white text-sm font-semibold px-6 py-3 rounded-md hover:opacity-90 transition-opacity"
            >
              Contact us
            </Link>
          </div>
        </div>

        <div className="border-t border-white/15 mt-12 pt-6 flex flex-col md:flex-row justify-between gap-3 text-white/50 text-xs">
          <span>© {new Date().getFullYear()} {brand.name}. All rights reserved.</span>
          <div className="flex gap-5">
            <a href="#" className="hover:text-white">Privacy Policy</a>
            <a href="#" className="hover:text-white">Cookie Policy</a>
            <a href="#" className="hover:text-white">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
